import axiosClient from '@/config/api/axios'
import { WORKFLOWS } from '@/config/api/endpoints'
import { workflowFromRow } from './workflowMappers'

/**
 * Start a drafted schedule.
 *
 * Resends the whole cadence rather than just `enabled`. The API rewrites cron
 * and timezone together from whatever the patch carries, and refuses an enable
 * that arrives without them — so a partial patch would 422 rather than start
 * anything. That is why the card carries the timezone at all.
 */
export async function startWorkflowSchedule({ workflowId, cron, timezone }) {
  const { data } = await axiosClient.patch(`${WORKFLOWS}/${workflowId}`, {
    schedule: { enabled: true, cron, timezone },
  })
  return workflowFromRow(data)
}

export async function discardWorkflow({ workflowId }) {
  await axiosClient.delete(`${WORKFLOWS}/${workflowId}`)
}

export async function fetchWorkflow({ workflowId, signal }) {
  const { data } = await axiosClient.get(`${WORKFLOWS}/${workflowId}`, { signal })
  return workflowFromRow(data)
}
